export type OrdersFilterObject = {
	showRed: boolean;
	showGreen: boolean;
	showDone: boolean;
	searchInput: string;
};

export const ORDERS_FILTER_STORAGE_KEY = 'kala-orders-filters';

export const DEFAULT_ORDERS_FILTER_OBJECT: OrdersFilterObject = {
	searchInput: '',
	showDone: true,
	showGreen: true,
	showRed: true
};

function isOrdersFilterObject(value: unknown): value is OrdersFilterObject {
	if (!value || typeof value !== 'object') {
		return false;
	}

	const candidate = value as Record<string, unknown>;
	return (
		typeof candidate.showRed === 'boolean' &&
		typeof candidate.showGreen === 'boolean' &&
		typeof candidate.showDone === 'boolean' &&
		typeof candidate.searchInput === 'string'
	);
}

export function readOrdersFiltersFromSession(): OrdersFilterObject | null {
	try {
		const raw = sessionStorage.getItem(ORDERS_FILTER_STORAGE_KEY);
		if (!raw) {
			return null;
		}

		const parsed = JSON.parse(raw) as unknown;
		return isOrdersFilterObject(parsed) ? parsed : null;
	} catch {
		return null;
	}
}

export function writeOrdersFiltersToSession(filterObject: OrdersFilterObject): void {
	try {
		sessionStorage.setItem(ORDERS_FILTER_STORAGE_KEY, JSON.stringify(filterObject));
	} catch {
		// Ignore quota / private-mode write failures.
	}
}

export function clearOrdersFiltersFromSession(): void {
	try {
		sessionStorage.removeItem(ORDERS_FILTER_STORAGE_KEY);
	} catch {
		// Ignore storage failures.
	}
}
